import { call, put, takeEvery } from "redux-saga/effects";
import { TEMPLATE } from "./actionTypes"
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { getListaTemplate, getTemplate, getTemplateHistory, getTemplateHistoryList, saveTemplate } from "./actions";
import { LOGO_URL, TEMPLATE_URL } from "../../helpers/url_api_helper";
import moment from "moment";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";
import { stringToBase64 } from "../../helpers/base64_helper";

function* listarTemplates({ payload }) {
    const filterTemplate = payload;

    try {
        emptyStringToNull(filterTemplate);
        const res = yield call(TEMPLATE_URL.getTemplateLista, filterTemplate);
        yield put(getListaTemplate.success(res));
    } catch (error) {
        yield put(getListaTemplate.fail(normalizeApiError(error, "ERROR")))
    }
}

function* obterTemplate({ payload }) {
    const { templateId } = payload;

    try {
        const logos = yield call(LOGO_URL.getLogoAll);

        const logosOptions = logos.map(logo => ({
            value: logo.id,
            label: logo.title
        }));

        if (!templateId) {
            yield put(getTemplate.success({
                logosOptions,
                logo: null,
            }));
            return;
        }

        const templates = yield call(TEMPLATE_URL.getTemplate, templateId);

        const selectedLogo = logosOptions.find(o => o.value === templates.idLogo) || null;

        const res = {
            ...templates,
            createDate: moment(templates.createDate).format("DD MMM/YY hh:mm A"),
            updateDate: templates.updateDate
                ? moment(templates.updateDate).format("DD MMM/YY hh:mm A")
                : "",
            logosOptions,
            logo: selectedLogo
        };

        yield put(getTemplate.success(res));

    } catch (error) {
        yield put(getTemplate.fail(normalizeApiError(error, "Something went wrong obtaining the template")))
    }
}

function* salvarTemplate({ payload }) {
    const { body, method } = payload;
    try {
        body.content = stringToBase64(body.content)
        if (method === "POST") {
            yield call(TEMPLATE_URL.postTemplate, body);
            yield put(saveTemplate.success(true));
        } else {
            yield call(TEMPLATE_URL.putTemplate, body);
            yield put(saveTemplate.success(true));
        }
    } catch (error) {
        yield put(saveTemplate.fail(normalizeApiError(error, "Something went wrong saving the template, please try again later")))
    }

}

function* listarTemplatesHistory({ payload }) {
    try {
        const { templateId, page } = payload;
        const res = yield call(TEMPLATE_URL.getTemplateHistoryList, templateId, page);
        yield put(getTemplateHistoryList.success(res));
    } catch (error) {
        yield put(getTemplateHistoryList.fail(normalizeApiError(error, "Something went wrong retrieving the system's template, please try again later")))
    }
}

function* obterTemplateHistory({ payload }) {
    const { idHistory } = payload;
    try {
        const logos = yield call(LOGO_URL.getLogoAll);
        const template = yield call(TEMPLATE_URL.getTemplateHistory, idHistory);

        const logosOptions = logos.map(logo => ({
            value: logo.id,
            label: logo.title
        }));
        
        const selectedLogo = logosOptions.find(o => o.value === template.idLogo) || null;
        
        const res = {
            ...template,
            createDate: moment(template.createDate).format("DD MMM/YY hh:mm A"),
            updateDate: template.updateDate
                ? moment(template.updateDate).format("DD MMM/YY hh:mm A")
                : "",
            logo: selectedLogo
        };

        yield put(getTemplateHistory.success(res));
    } catch (error) {
        yield put(getTemplateHistory.fail(normalizeApiError(error, "Something went wrong retrieving the system's template, please try again later")))
    }
}

function* TemplateSaga() {
    yield takeEvery(TEMPLATE.GET_LIST.REQUEST, listarTemplates);
    yield takeEvery(TEMPLATE.GET_TEMPLATE.REQUEST, obterTemplate);
    yield takeEvery(TEMPLATE.SAVE_TEMPLATE.REQUEST, salvarTemplate);
    
    yield takeEvery(TEMPLATE.GET_TEMPLATE_HISTORY_LIST.REQUEST, listarTemplatesHistory);
    yield takeEvery(TEMPLATE.GET_TEMPLATE_HISTORY.REQUEST, obterTemplateHistory);
}

export default TemplateSaga